export type AreaKey = "pension" | "service";

type AreaRouteConfig = {
  entry: string;
  primaryList: string;
  secondaryList: string;
  primaryCreate: string;
};

export const areaRouteMap: Record<AreaKey, AreaRouteConfig> = {
  pension: {
    entry: "/pension",
    primaryList: "/bookings",
    secondaryList: "/bookings?view=spaces",
    primaryCreate: "/bookings/new",
  },
  service: {
    entry: "/service",
    primaryList: "/service-offers",
    secondaryList: "/service-bookings",
    primaryCreate: "/service-offers/new",
  },
};

export const areaKeys = Object.keys(areaRouteMap) as AreaKey[];

export function getAreaRoutes(area: AreaKey): AreaRouteConfig {
  return areaRouteMap[area];
}

export function isAreaKey(value: unknown): value is AreaKey {
  return value === "pension" || value === "service";
}

export function findAreaByPath(pathname?: string | null): AreaKey | null {
  if (!pathname) {
    return null;
  }

  if (
    pathname === "/service-bookings" ||
    pathname.startsWith("/service-bookings/") ||
    pathname === "/service-series" ||
    pathname.startsWith("/service-series/")
  ) {
    return "service";
  }
  for (const area of areaKeys) {
    const routes = getAreaRoutes(area);
    const routeValues = Object.values(routes);
    const hasMatch = routeValues.some((route) => {
      const [routePath] = route.split("?");
      return pathname === routePath || pathname.startsWith(`${routePath}/`);
    });

    if (hasMatch) {
      return area;
    }
  }

  return null;
}

export function getDefaultAreaKey(
  hasPensionModule: boolean,
  hasCourseModule: boolean
): AreaKey {
  if (hasPensionModule) {
    return "pension";
  }

  if (hasCourseModule) {
    return "service";
  }

  return "pension";
}
